import type { Block, ImageRef, Text } from '@ksa/model'
import { SiteImage, SiteText, hasText } from '../context.tsx'

type Item = { image: ImageRef; caption: Text }
type Props = { items: Item[]; columns: number }

export function GalleryBlock({ block }: { block: Block }) {
  const p = block.props as unknown as Props
  const items = p.items ?? []
  const masonry = block.variant === 'masonry'

  return (
    <section className="s-section">
      <div className="s-wrap">
        <div
          className={`s-grid${p.columns === 2 ? ' s-grid--2' : p.columns === 4 ? ' s-grid--4' : ''}`}
          style={
            // The staggered variant nudges every second item down. `nth-child` in a stylesheet would
            // be tidier and is wrong here: the offset must follow the VISUAL order, and under RTL the
            // visual order of a grid is reversed while `nth-child` is not.
            masonry ? { alignItems: 'start' } : undefined
          }
        >
          {items.map((item, i) => (
            <figure key={i} style={{ margin: 0, marginBlockStart: masonry && i % 2 === 1 ? '2rem' : 0 }}>
              <SiteImage image={item.image} />
              {hasText(item.caption) && (
                <figcaption className="s-small s-faint" style={{ marginBlockStart: '0.5rem' }}>
                  <SiteText value={item.caption} />
                </figcaption>
              )}
            </figure>
          ))}
        </div>
      </div>
    </section>
  )
}
